const lightThemeData = {
  colors: {
    primaryColor: '#5678ff',
    secondaryColor: '#F7F7F7',
    black: '#040D2D',
    primaryTextColor: '#040D2D',
    secondaryTextColor: '#F7F7F7',
    error: '#F80E38',
    success: '#2DF90B',
    gray: '#9B9EAB',
    yellow: '#fbe51f',
    primaryHoverColor: '#4563d9',
    primaryHoverTextColor: '#F7F7F7',
    secondaryHoverColor: 'rgba(86, 120, 255, 0.1)',
    secondaryHoverTextColor: '#040D2D',
    backgroundColor: '#F7F7F7',
    secondaryBackgroundColor: '#F7F7F7',
    tretiaryBackgroundColor: '#EFEFEF',
    plainBackgroundColor: '#FFFFFF',
    mainWhite: '#F7F7F7',
    status: {
      blue: '#0B78F9',
      purple: '#1E0BF9',
      magenta: '#900BF9',
      pink: '#F90BB6',
      red: '#F90B0B',
    },
  },
  palette: {
    primary: {
      main: '#5678ff',
      light: '#819aff',
      dark: '#4563d9',
      contrastText: '#F7F7F7',
    },
    secondary: {
      main: '#F7F7F7',
      light: '#819aff',
      dark: '#4563d9',
      contrastText: '#040D2D',
  
    },
    error: {
      main: '#F80E38',
      light: '#f75b77',
      dark: '#af0b29',
      contrastText: '#F7F7F7',
    },
    success: {
      main: '#2DF90B',
      light: '#84ff6e',
      dark: '#27b90d',
      contrastText: '#F7F7F7',
    },
    warning: {
      main: '#fbe51f',
      light: '#ffee59',
      dark: '#c4b218',
      contrastText: '#F7F7F7',
    },
    info: {
      main: '#c9ccda',
      light: '#9B9EAB',
      dark: '#848485',
      contrastText: '#040D2D',
    },
    text: {
      primary: '#040D2D',
      secondary: '#9B9EAB',
    },
  },
  typography: {
    'fontFamily': 'Mulish',
    'fontSize': 14,
    'letterSpacing': 1,
    'color': '#040D2D',
  },
};

export default lightThemeData;